export default __webpack_public_path__ + "public/assets/images/f3a8b756b218979c06a1c4b016f0ac56.png";